// extracted by mini-css-extract-plugin
export default {"tabs":"ProductDetails_tabs__Clvm+","tab__button":"ProductDetails_tab__button__1CDYc","active":"ProductDetails_active__sj02n","tab__content":"ProductDetails_tab__content__om-vR"};